import * as api_config from '../../config/api_config'

let address = `${api_config.ADDRESS}/admin`

export default {
    shopEditProduct (axios, slug, payload) {
        return axios.patch(`${address}/products/${slug}/shop_edit`, payload, { headers: api_config.HEADERS })
    }
}
